import { render, staticRenderFns } from "./Read.vue?vue&type=template&id=305f218b&scoped=true&"
import script from "./Read.vue?vue&type=script&lang=js&"
export * from "./Read.vue?vue&type=script&lang=js&"
import style0 from "./Read.vue?vue&type=style&index=0&id=305f218b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305f218b",
  null
  
)

export default component.exports